import { useMessagesWatcher } from '@/hooks/useMessagesWatcher';
import { useSagaNavigator } from '@/hooks/useSagaNavigator';
import { Outlet } from 'react-router-dom';

export const Layout = () => {
  useMessagesWatcher();
  useSagaNavigator();
  return <Outlet />;
};
